export enum ArtistStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}
